import axiosInstance from '../axiosInterceptor/axiosInstance'

const addSeasonTeam = async (data) => {
  const { orgId, ...restData } = data
  const url = `v1/orgs/${orgId}/season-teams`
  return axiosInstance.post(url, restData)
}

export default addSeasonTeam
